var _defs, _rect, _polygon, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack1109({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#fff;}.b{stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 3.04,
    y: 0.66,
    width: 5.08,
    height: 7.01
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "13.19 9.35 8.12 9.35 8.12 2.33 13.19 2.33 10.74 5.84 13.19 9.35"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 2.81,
    y1: 0.66,
    x2: 2.81,
    y2: 15.34
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack1109);
export default __webpack_public_path__ + "static/media/Symbolpack_1_109.726793f5ac8f5510a415d2c1c2dc239a.svg";
export { ForwardRef as ReactComponent };